import { type BiLogger } from '../../../Provider/BiLogger/BiLogger';
import { type AppDispatch } from '../../../../store';
import {
  onShippingContactSelected,
  type ShippingAddress,
  type OnShippingContactSelectedReturn,
} from '../../../../actions/googlePay/onShippingContactSelected';
import { type OnShippingMethodSelected } from './createOnShippingMethodSelected';

type CreateOnShippingContactSelectedParams = {
  transactionInfo: google.payments.api.TransactionInfo;
  biLogger: BiLogger;
  dispatch: AppDispatch;
  onShippingMethodSelected: OnShippingMethodSelected;
};

type CreateOnShippingContactSelectedReturn = Promise<OnShippingContactSelectedReturn>;

type CreateOnShippingContactSelected = (
  params: CreateOnShippingContactSelectedParams,
) => (shippingAddress: ShippingAddress) => CreateOnShippingContactSelectedReturn;

export const createOnShippingContactSelected: CreateOnShippingContactSelected =
  ({ transactionInfo, biLogger, dispatch, onShippingMethodSelected }) =>
  (shippingAddress) => {
    return dispatch(
      onShippingContactSelected({ transactionInfo, biLogger, shippingAddress, onShippingMethodSelected }),
    ).unwrap();
  };
